<style scoped>
.location-button{
  margin-bottom: 10px;
}
.alert-noti{
  position: fixed;
  right: 5px;
  bottom: 5px;
  background: #2196f3;
  padding: 10px;
  margin: 0px;
  border-radius: 14px;
  font-size: 12px;
  color: #fff;
  z-index: 2;
  margin-left: 5px;
}
.edges.working{
  position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: #fff;
    z-index: 2;
    margin: 0px;
    display: flex;
    flex-direction: column;
}
.edges.working .button-wrapper{
  padding: 10px;
  margin: 0px;
}
#edge-locations{
  width: 100%;height: 500px;background-color: grey
}
.edges.working #edge-locations{
  height: 100%;
}
</style>
<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <form v-on:submit.prevent="submitForm">
        <h3 class="mt0">{{ getTitleText }}</h3>
        <ul class="breadcrumb">
          <li>
            <router-link :to="{ name: 'ManageGarden' }">{{
              "My gardens" | translate
            }}</router-link>
          </li>
          <li>{{ getTitleText }}</li>
        </ul>
        <div class="row">
          <div class="col-md-8 mb20">
            <label class="mt20"
              >{{ "Name" | translate }}
              <span class="required">(*)</span>:</label
            >
            <input
              v-model="item.name"
              ref="name"
              required
              :placeholder="'Input garden name' | translate"
              class="form-control"
            />
            <label class="mt20">{{ "Certificate" | translate }}:</label>
            <p v-if="item.certificate">
              <label class="no-strong">
                <input type="checkbox" v-model="item.is_converting" />
                {{ "Is converting" | translate }}
              </label>
            </p>
            <select
              class="form-control"
              v-if="list_certificates"
              v-model="item.certificate"
            >
              <option value="">{{ "Không có" | translate }}...</option>
              <option
                v-for="item in list_certificates"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </option>
            </select>

            <div class="mt20" v-if="ready ">
              <selectlocation
                :province="item.province_id"
                :district="item.district_id"
                :commune="item.commune_id"
                :hide_map="show_edges"
                :p_location="item.location_coord"
                @updateLocation="updateLocation"
              ></selectlocation>
              <a v-if="!show_edges" class="btn btn-primary btn-sm mt20" v-on:click="getEdgeLocations" ><i class="fas fa-map-marker-alt"></i> Lấy tọa độ biên của vườn</a>
            </div>
            <div v-if="show_edges" class="mt20 mb10 edges" v-bind:class="{working:!edge_done}" >
              <p class="button-wrapper" >
                <a class="btn btn-danger btn-sm location-button" v-if="edge_locations.length > 0 && edge_done" v-on:click="removeEdgeLocations" ><i class="fas fa-trash-alt"></i> Xóa toàn bộ tọa độ biên</a>
                <a class="btn btn-primary btn-sm location-button" :disabled="edge_obtaining_location" v-if="!edge_done" v-on:click="getEdgeLocations" ><i class="fas fa-map-marker-alt"></i> Lấy vị trí hiện tại làm biên</a>
                <a class="btn btn-success btn-sm location-button" v-if="!edge_done && edge_locations.length >= 3" v-on:click="finalizeSelectEdgeLocations" ><i class="fas fa-check"></i> Hoàn thành</a>
                <a class="btn btn-warning btn-sm location-button" v-if="!edge_done && edge_locations.length > 0" v-on:click="removeRecentEdgeLocation" ><i class="fas fa-undo"></i> Xóa tọa độ biên gần nhất</a>
                <a class="btn btn-danger btn-sm location-button" v-if="!edge_done" v-on:click="cancelEdgeLocations" ><i class="fas fa-window-close"></i> Hủy & thoát</a>
                
              </p>
              <div id="edge-locations"  ></div>
              <p class="mt10" v-if="edge_done">
                <strong>Diện tích:</strong><span> {{ toCommas(edge_area) }} m2</span><br/>
                <strong>Chiều dài:</strong><span> {{ toCommas(edge_distance) }} m</span>
              </p>
            </div>

            <label  class="mt20">{{ "Nhập sản phẩm vườn có trồng " | translate }}:</label>
            <input
              name="tags"
              class="some_class_name"
              placeholder="nhập tên sản phẩm"
              value
              autofocus
            />
          </div>
          <div class="col-md-4">
            <input
              type="file"
              id="file-upload"
              ref="file"
              v-on:change="handleFileUpload()"
              style="display: none"
            />
            <div class="feature-image mt10">
              <p>
                <label>Ảnh Đại Diện</label>
              </p>
              <div class="wrapper" v-on:click="triggerFile">
                <img :src="src_image" />
                <span class="upload-icon">
                  <i class="fa fa-camera"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{ getOKText }}
        </button>
      </form>
    </div>
    <p class="alert-noti" v-if="noti_alert">{{ noti_alert }}</p>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import Config from '@/helpers/config'
import Utils from '@/helpers/utils'
import LocationHelper from '@/helpers/location'
import MyHeader from '@/components/Layout/Header'
import Tagify from '@yaireo/tagify'
import Alertify from "alertifyjs"
// import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: 'FormGarden',
  components: {
    Loading,
    selectlocation,
    MyHeader
  },
  computed: {
    getTitleText () {
      if (this.item.id) {
        return this.$t('Update garden')
      } else {
        return this.$t('Add garden')
      }
    },
    getOKText () {
      if (this.item.id) {
        return this.$t('Update')
      } else {
        return this.$t('Add')
      }
    }
  },
  data () {
    let dateFormat = 'DD/MM/YYYY'
    return {
      ready: false,
      tagify: null,
      noti_alert: "",
      geo_watcher: null,
      edge_area: 0,
      edge_obtaining_location: false,
      edge_distance: 0,
      show_edges: false,
      edge_done: false,
      edge_center_point: null,
      edge_locations: [],
      edge_markers: [],
      edge_map: null,
      edge_polyline: null,
      list_certificates: [
        { id: 'VietGAP', name: 'VietGAP' },
        { id: 'LocalGAP', name: 'LocalGAP' },
        { id: 'GlobalGAP', name: 'GlobalGAP' },
        { id: 'Rainforest Alliance', name: 'Rainforest Alliance' },
        { id: 'USDA Organic', name: 'USDA Organic' },
        { id: 'EU Organic', name: 'EU Organic' },
        { id: 'Hữu Cơ Việt Nam', name: 'Hữu Cơ Việt Nam' }
      ],
      working: false,
      src_image: '/static/images/no-photo.jpg',
      all_products: [],
      selectedFile: false,
      dateFormat: dateFormat,
      config: {
        format: dateFormat,
        locale: 'vi',
        maxDate: new Date()
      },
      item: {}
    }
  },
  created () {
    // clone from original params
  },
  methods: {
    toCommas(value) {
      return Utils.toCommas(value);
    },
    defaultValue () {
      return {
        name: '',
        is_converting: false,
        certificate: '',
        province_id: '',
        district_id: '',
        commune_id: ''
      }
    },
    updateLocation (data) {
      for (let key in data) {
        this.item[key] = data[key]
      }
    },
    init () {
      this.src_image = '/static/images/no-photo.jpg'
      this.selectedFile = false

      if (this.item.id) {
        if (this.item.banner_image) {
          this.src_image = this.item.banner_image.thumb_path
        }
      } else {
        this.item = this.defaultValue()
      }
      this.getProducts()
      this.ready = true
      console.log('this.item.edge_locations',this.item.edge_locations)
      if (this.item.edge_locations && this.item.edge_locations.length >0){
        this.edge_locations = JSON.parse(JSON.stringify(this.item.edge_locations));
        this.edge_done = true;
        setTimeout(()=>{
          this.show_edges = true;
          setTimeout(()=>{
            this.renderEdge(0)
          },100)
        },200)        
      }
      //   for (let key in this.searchparams) {
      //     this.search_params[key] = this.searchparams[key]
      //   }
    },
    renderEdge(index){
      let position = this.edge_locations[index]
      this.renderEdgeLocations(position, index+1)
      if (index < this.edge_locations.length -1){
        setTimeout(()=>{
          this.renderEdge(index+1)
        },100)
      }else{
        setTimeout(()=>{
          this.finalizeSelectEdgeLocations()
        },100)
      }
    },
    submitForm () {
      if (this.show_edges && !this.edge_done && this.edge_locations.length > 0 ){
        this.$alertify.error('Bạn cần hoàn thành việc chọn tọa độ biên hay hủy trước khi cập nhật vườn')
        return
      }
      let data = JSON.parse(JSON.stringify(this.item))

      data.product_ids = this.tagify.value.map(item => {
        return item.id
      })

      data.edge_locations = this.edge_locations
      

      let request
      if (this.item.id) {
        request = Utils.requestV2(this, true).put(`/gardens/`, data)
      } else {
        request = Utils.requestV2(this, true).post(`/gardens/`, data)
      }
      this.working = true
      request
        .then((response) => {
          let data = response.data
          Utils.refreshUser(this)

          this.logicFinish()
          this.working = false
        })
        .catch((error) => {
          // this.working = false;
          Utils.showErrorMessage(this, error.response)
          this.working = false
        })
        .finally(() => {})
    },

    triggerFile () {
      this.$refs.file.click()
    },
    logicFinish () {
      if (this.item.id) {
        this.$alertify.success(this.$t('Your garden is updated'))
      } else {
        this.$alertify.success(this.$t('Garden is added'))
        this.item = this.defaultValue()
        this.ready = false
        setTimeout(() => {
          this.ready = true
        }, 50)
      }
      this.working = false
    },
    uploadFile () {
      let formData = new FormData()
      const files = document.querySelector('[type=file]').files
      formData.append('file', files[0])
      let headers = {
        'Content-Type': 'multipart/form-data'
      }
      Utils.requestV2(this, true)
        .post('/upload', formData, { headers: headers })
        .then((response) => {
          console.log('response', response)
          this.item.banner_image_id = response.data.id
        })
        .catch(function (e) {
          console.log(e)
          console.log('FAILURE!!')
        })
        .finally(() => {
          this.working = false
        })
    },
    handleFileUpload () {
      let file = this.$refs.file.files[0]
      if (file.size > 3000000) {
        return alert('Ảnh phải có dung lượng nhỏ hơn 3MB')
      }
      var validExtensions = ['jpg', 'png', 'jpeg']
      var reader = new FileReader()
      let _this = this
      reader.onloadend = (e) => {
        let arr = new Uint8Array(e.target.result).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        let mimeType = Utils.mimeType(header)
        if (mimeType === 'unknown') {
          this.selectedFile = false
          return _this.$alertify.alertWithTitle(
            _this.$t('Confirm'),
            _this.$t('Only these file types are accepted') +
              ' : ' +
              validExtensions.join(', ')
          )
        }
        var image = new Image()

        this.selectedFile = true
        var base64Image = new Buffer(e.target.result, 'binary').toString(
          'base64'
        )
        image.src = 'data:image/png;base64,' + base64Image
        image.onload = () => {
          console.log(image.width)
          if (image.width < 800) {
            alert('Ảnh phải có chiều dài tối thiểu là 800px')
            return
          }
          if (image.height < 400) {
            alert('Ảnh phải có chiều rộng tối thiểu là 400px')
            return
          }

          _this.src_image = 'data:image/png;base64,' + base64Image
          this.uploadFile()
        }
        // _this.src_image = "data:image/png;base64," + base64Image;
      }
      reader.readAsArrayBuffer(file)
    },
    getProducts () {
      Utils.getAllProducts(this, {}).then((products) => {
        this.products = products

        setTimeout(() => {
          let input = document.querySelector('input[name=tags]')
          // init Tagify script on the above inputs
          let whiteList = []
          if (this.products.length > 0) {
            whiteList = this.products.map(function (item) {
              return { value: item.name, id: item.id, searchBy: item.unaccent_name }
            })
          }
          this.tagify = new Tagify(input, {
            whitelist: whiteList,
            enforceWhitelist: true
          })
          if (this.item && this.item.products) {
            let insert = this.item.products.map(product => {
              return {value: product.name, id: product.id}
            })
            this.tagify.addTags(insert)
          }
        }, 100)
      })
    },
    getTestLocations(){
      let list = [
        {lat:10.732778195586135, lng:106.65281223821101},
        {lat:10.73162313529263, lng:106.65311751071333},
        {lat:10.73177629271242, lng:106.65387744438934},
    
        {lat:10.732509839817007, lng:106.65382254835026},
        {lat:10.732609099644238, lng:106.65419017465099},
        {lat:10.733039225185625, lng:106.65412001696001}
      ];
      if (this.edge_locations.length >= list.length ){
        console.log('reach las')
        return list[0]
      }
      return list[this.edge_locations.length]

    },
    finalizeSelectEdgeLocations(){
      this.drawLines(true)
      if (this.geo_watcher){
        navigator.geolocation.clearWatch(this.geo_watcher)
        this.geo_watcher = null;
      }
      if (this.edge_center_point && this.edge_map){
        this.edge_map.removeObject(this.edge_center_point)  
        this.edge_center_point = null
      }

    },
    removeRecentEdgeLocation(){
      this.edge_locations.pop()
      let marker = this.edge_markers.pop()
      this.edge_map.removeObject(marker);
      this.drawLines(false);
    },

    getEdgeLocations(){
      if (!this.edge_obtaining_location){
          this.edge_obtaining_location = true;
      }
      if (this.geo_watcher){
        return
      }
      this.show_edges = true
      let options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      this.geo_watcher = navigator.geolocation.watchPosition((position) => {
        
        let coords = position.coords;
        let result = {
          lat: coords.latitude,
          lng: coords.longitude
        }
        console.log('real result', result)
        if (this.item.name.indexOf("test location") != -1 ){
          result = this.getTestLocations()
          console.log('actual result', result)
        }
        this.renderMap(result)
        setTimeout(()=>{
          this.renderCenterPoint(result)
          if (!this.edge_obtaining_location){
            return;
          }

          let maxAcceptDistance = 5;
          let accuracy = coords.accuracy.toFixed(1)
          if (accuracy > maxAcceptDistance ){
              this.noti_alert =`Vui lòng chờ, sai lệch ${accuracy}m > ${maxAcceptDistance}m, bạn có thể xoay điện thoại để lấy vị trí tốt hơn`
              return
          }
          this.noti_alert = ''
          this.edge_obtaining_location = false
          if (this.edge_locations.length > 0 && LocationHelper.computeDistance([this.edge_locations[this.edge_locations.length -1],result]) <= 1){
            this.$alertify.error('Vị trí của bạn không thay đổi nhiều, vui lòng di chuyển')
            return
          }
          this.$alertify.success(`Sai lệch ${accuracy}m < ${maxAcceptDistance}m`)
          this.edge_locations.push(result)
          this.renderEdgeLocations(result, this.edge_locations.length)
          
        },200)

      }, (err) =>{
        this.noti_alert = '';
        this.$alertify.error(`Lỗi: ${err.message}, vui lòng thử lại`)
        this.edge_obtaining_location = false
      }, options)

    },
    renderCenterPoint(position){
      if (this.edge_center_point){
        this.edge_map.removeObject(this.edge_center_point)  
        this.edge_center_point = null
      }
      this.edge_center_point = new H.map.DomMarker(position,  {volatility: true});
      this.edge_map.addObject(this.edge_center_point);
    },
    renderMap(position){
      if (this.edge_map == null){
          var platform = new H.service.Platform({
            apikey: Config.apiKeyHereMap
          });
          var defaultLayers = platform.createDefaultLayers();

          //Step 2: initialize a map - this map is centered over Europe
          this.edge_map = new H.Map(document.getElementById('edge-locations'),
          defaultLayers.raster.satellite.map,{
            center: position,
            zoom: 18,
            pixelRatio: window.devicePixelRatio || 1
          });

          var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.edge_map));

          // Create the default UI components
          var ui = H.ui.UI.createDefault(this.edge_map, defaultLayers);
      
        }else{
          this.edge_map.setCenter(position);
        }
    },
    renderEdgeLocations(position, index) {
        var svgMarkup = '<svg  width="24" height="24" xmlns="http://www.w3.org/2000/svg">' +
      '<rect stroke="black" fill="white" x="1" y="1" width="22" height="22" />' +
      '<text x="12" y="18" font-size="12pt" font-family="Arial" font-weight="bold" ' +
      'text-anchor="middle" fill="orange" >'+ (index) +'</text></svg>';
      var cubsIcon = new H.map.Icon(svgMarkup)
      console.log('position', position)
      this.renderMap(position)
          
      var cubsMarker = new H.map.Marker(position,{icon: cubsIcon});
      this.edge_markers.push(cubsMarker)
      this.edge_map.addObject(cubsMarker);
      
      this.drawLines(false)
    
    },
    cancelEdgeLocations(){
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        "Bạn có muốn chắc chắn thoát và mất dữ liệu tọa độ góc đã chọn?",
        () => {
          this.removeEdgeLocations()
        })
    },
    removeEdgeLocations(){
      if (this.edge_map){
        this.edge_map.dispose()
        this.edge_map = null;
        this.edge_center_point = null;
      }
      this.edge_locations = []
      this.edge_polyline = null;
      this.show_edges = false;
      this.edge_done = false
      if (this.geo_watcher){
        navigator.geolocation.clearWatch(this.geo_watcher)
        this.geo_watcher = null;
      }
    },
    drawLines(isFinal){
      if(this.edge_polyline){
        this.edge_map.removeObject(this.edge_polyline)  
        this.edge_polyline = null;
      }
      console.log('this.edge_locations.length', this.edge_locations.length)
      if (this.edge_locations.length <= 1){
        return;
      }
      let lines_strings = new H.geo.LineString();

      this.edge_locations.forEach(function(position){
        
        lines_strings.pushPoint(position);
      })

      if (isFinal){
        lines_strings.pushPoint(this.edge_locations[0]) // back to first location
      }
      console.log('lines_strings', lines_strings)

      if (isFinal){
        this.edge_area = LocationHelper.computeArea(this.edge_locations)
        this.edge_distance = LocationHelper.computeDistance(this.edge_locations)
        this.edge_polyline = new H.map.Polygon(lines_strings, {
          style: {
            fillColor: '#2196f3',
            strokeColor: '#5cb85c',
            lineWidth: 2
          }
        })
        this.edge_done = true
      }else{
        this.edge_polyline = new H.map.Polyline(
          lines_strings, { style: { lineWidth: 4 }}
        )
      }
      this.edge_map.addObject(this.edge_polyline);

      this.edge_map.setCenter(this.edge_locations[this.edge_locations.length -1]);
    
    }
  },
  beforeDestroy() {
    if (this.geo_watcher){
      navigator.geolocation.clearWatch(this.geo_watcher)
    }
  },
  mounted () {
    this.garden_id = this.$route.params.id

    let wating = []
    if (this.garden_id) {
      wating.push(
        Utils.requestV2(this, true).get(`/gardens/${this.garden_id}`)
      )
    }

    Promise.all(wating).then((values) => {
      if (this.garden_id) {
        this.item = values[0].data
      }
      this.init()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/FormGarden.vue